import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/dostavkee/_sidebar-layout/documents/')({
    onEnter: () => {
        document.title = 'Dostavkee - Документы'
    },
})
